import React from 'react';
import copyArray from '../../../../infrastructure/helpers/common/copyArray';
import operandDisplayHelper from '../../../../infrastructure/helpers/functions/operand/operandDisplayHelper';
import Lookup from '../../../../types/functions/Lookup';
import Operand from '../../../../types/functions/Operand/Operand';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import CustomDataSourceFields from '../../../../types/report/CustomDataSourceFields';
import Dictionary from '../../../../types/report/Dictionary';
import ReportFieldDefinition from '../../../../types/report/ReportFieldDefinition';
import ReportVariable from '../../../../types/report/ReportVariable';
import getArgument from './getArgument';
import dictionaryHelper from '../../../../infrastructure/helpers/functions/dictionaries/dictionaryHelper';
import DictionaryField from '../../../../types/report/DictionaryField';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import actions from '../../../../store/actions';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import store from '../../../../store/store';
import OperandDetails from '../../../../types/functions/Operand/OperandDetails';
import locationType from '../../../../types/functions/Location/LocationType';

const addComma = (i: number, args: Operand[]): boolean => {
    return (
        (i >= 0) &&
        (i < args.length - 1)
    );
};

const buildArgumentDescription = (field: DictionaryField): string => {

    return `${field.name}: ${field.dataType}`;
};

const onShowDefinitionClick = (details: OperandDetails, location: ReportLogicLocation): void => {
    store.dispatch({ type: actions.navigation.navigateToItem, payload: { details, location } });
}

const getDictionaryOperand = (
    operand: Operand,
    operandNumber: number,
    argumentIndexes: number[],
    functions: UserDefinedFunction[],
    globalFunctions: UserDefinedFunction[],
    lookups: Lookup[],
    dictionaries: Dictionary[],
    variables: ReportVariable[],
    dataSources: IngestionConfig[],
    reportFields: ReportFieldDefinition[],
    customDataSourceFields: CustomDataSourceFields,
    selectorNumber: number | null,
    onClick: (operandNumber: number, argumentIndexes: number[], event: React.MouseEvent<HTMLElement>) => void,
    disabled: boolean,
    reportConfigType: string,
    children?: JSX.Element
): JSX.Element => {

    let dictionary = dictionaryHelper.getByNumber(dictionaries, operand.dictionaryNumber)

    let tooltips = dictionary.fields.map(buildArgumentDescription);

    let details = operandDisplayHelper.getOperandDetails(operand, functions, globalFunctions, lookups, dictionaries, variables, dataSources, reportFields, customDataSourceFields, reportConfigType, null);

    let location = { statement: locationType.statement.dictionary, statementNumber: operand.dictionaryNumber } as ReportLogicLocation;

    let args: JSX.Element[] = (operand.arguments as Operand[])
        .map((x, i, arr) => getArgument(x, operandNumber, copyArray(argumentIndexes).concat([i]), tooltips[i], functions, globalFunctions, lookups,
            dictionaries, variables, dataSources, reportFields, customDataSourceFields, selectorNumber, onClick, i, addComma(i, arr), disabled, reportConfigType));

    return (
        <div className='flex-wrap'>
            <button className="transparent-button code" onClick={(event) => onClick(operandNumber, argumentIndexes, event)} disabled={disabled} >
                {details.displayText}
            </button>

            <span className="code">(</span>

            {args}

            <span className="code">)</span>
            <button className="transparent-button" onClick={() => onShowDefinitionClick(details, location || {} as ReportLogicLocation)} title="Go to definition">*</button>
            {children}
        </div>
    );
};

export default getDictionaryOperand;